import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { getEnabledClients } from '../config/clients'
import { getOnClientSwitch } from '../managers/UIManager'

const ROUTE_BY_CLIENT: Record<string, string> = {
  aana: '/AANA',
  pioneers: '/Pioneers',
  'freedom-fighters': '/FreedomFighters',
  rockardemo: '/RockARDemo',
}

export default function CollectionsScreen() {
  const navigate = useNavigate()

  const collections = useMemo(
    () => getEnabledClients().filter((client) => ['aana', 'pioneers', 'freedom-fighters', 'rockardemo'].includes(client.clientId)),
    [],
  )

  const openCollection = (clientId: string) => {
    getOnClientSwitch()?.(clientId)
    navigate(ROUTE_BY_CLIENT[clientId] ?? '/')
  }

  return (
    <section className="app-screen collections-screen">
      <header className="app-screen-header">
        <h2 className="app-screen-title">Collections</h2>
      </header>

      <div className="app-screen-scroll">
        <p className="collections-subtitle">Choose a collection to open its camera scanner.</p>

        <div className="collections-grid">
          {collections.map((client) => (
            <button key={client.clientId} className="collections-card" onClick={() => openCollection(client.clientId)}>
              <div className="collections-card-image-wrap">
                <img
                  className="collections-card-image"
                  src={(client as any).experienceItem?.thumbnail || '/rockarlogo.png'}
                  alt={client.clientName}
                />
              </div>
              <div className="collections-card-title">{client.clientName}</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}